import {
  BarChartOutlined,
  GoldOutlined,
  HomeOutlined,
  MessageOutlined,
  RobotOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { GuuruOutlined } from '@guuru/react-icon';

const mainMenu = [
  {
    name: 'Home',
    id: 'home',
    icon: HomeOutlined,
    abilities: [{ subject: 'Partner', field: 'highlights' }],
    route: '/',
  },
  {
    name: 'Conversations',
    id: 'interactions',
    icon: MessageOutlined,
    abilities: [{ subject: 'Partner', field: 'organization' }],
    route: '/interactions',
  },
  {
    name: 'Interaction',
    id: 'interactions',
    mpid: '-1',
    icon: MessageOutlined,
    abilities: [{ subject: 'Chat', field: 'messages' }],
    route: '/interactions/:id',
  },
  {
    name: 'Visitor',
    id: 'interactions-visitor',
    mpid: '-1',
    abilities: [{ subject: 'Chat', field: 'user' }],
    route: '/people/:id',
  },
  {
    name: 'IP',
    id: 'interactions-ip',
    mpid: '-1',
    abilities: [{ subject: 'Chat', field: 'userIp' }],
    route: '/ip/:ip',
  },
  {
    name: 'Content',
    id: 'content',
    icon: GoldOutlined,
    abilities: [{ subject: 'Partner', field: 'mentions' }],
    route: '/content',
  },
  {
    name: 'Automation',
    id: 'automation',
    icon: RobotOutlined,
    abilities: [{ subject: 'Partner', field: 'automation' }],
    route: '/automation',
  },
  {
    name: 'Experts',
    id: 'experts',
    mpid: 'community',
    abilities: [
      { subject: 'Partner', field: 'experts' },
      { subject: 'Partner', field: 'monitoring' },
    ],
    route: '/experts',
  },
  {
    name: 'Expert',
    id: 'experts-expert',
    mpid: '-1',
    abilities: [{ subject: 'Partner', field: 'expert' }],
    route: '/experts/:id',
  },
  {
    name: 'Community',
    icon: GuuruOutlined,
    id: 'community',
  },
  {
    name: 'Highlights',
    id: 'community-highlights',
    mpid: 'community',
    abilities: [{ subject: 'Partner', field: 'highlights' }],
    route: '/community/highlights',
  },
  {
    name: 'Building',
    id: 'community-building',
    mpid: 'community',
    abilities: [{ subject: 'Partner', field: 'submissions' }],
    route: '/building',
  },
  {
    name: 'Building',
    id: 'community-building',
    mpid: 'community-building',
    abilities: [{ subject: 'Partner', field: 'submissions' }],
    route: '/building/progress',
  },
  {
    name: 'Knowledge Base',
    id: 'community-pages',
    mpid: 'community',
    abilities: [
      { subject: 'Partner', field: 'pages' },
      { subject: 'Page', field: 'description' },
    ],
    route: '/pages',
  },
  {
    name: 'Updates',
    id: 'community-updates',
    mpid: 'community',
    abilities: [{ subject: 'Partner', field: 'news' }],
    route: '/community/updates',
  },
  {
    name: 'Monitoring',
    id: 'community-monitoring',
    mpid: 'community',
    abilities: [
      { subject: 'Partner', field: 'experts' },
      { subject: 'Partner', field: 'monitoring' },
    ],
    route: '/monitoring',
  },
  {
    name: 'Month Monitoring',
    id: 'community-monitoring',
    mpid: '-1',
    abilities: [{ subject: 'PartnerSettings', field: 'tasks' }],
    route: '/monitoring/:startDate/:endDate',
  },
  {
    name: 'Tasks',
    id: 'community-tasks',
    mpid: 'community',
    abilities: [{ subject: 'PartnerSettings', field: 'tasks' }],
    route: '/tasks',
  },
  {
    name: 'Reporting',
    id: 'reporting',
    icon: BarChartOutlined,
    route: '/reporting',
  },
  {
    name: 'Conversations',
    id: 'reporting-conversations',
    mpid: 'reporting',
    abilities: [{ subject: 'Partner', field: 'customCharts' }],
    route: '/reporting/conversations',
  },
  {
    name: 'Content',
    id: 'reporting-content',
    mpid: 'reporting',
    abilities: [{ subject: 'Partner', field: 'mentions' }],
    route: '/reporting/content',
  },
  {
    name: 'Automation',
    id: 'reporting-automation',
    mpid: 'reporting',
    abilities: [{ subject: 'Partner', field: 'automation' }],
    route: '/reporting/automation',
  },
  {
    name: 'Intent',
    id: 'reporting-automation-intent',
    mpid: '-1',
    abilities: [{ subject: 'Query', field: 'intents' }],
    route: '/intent/:intentId',
  },
  {
    name: 'Conversion',
    id: 'reporting-conversion',
    mpid: 'reporting',
    abilities: [{ subject: 'Chat', field: 'conversion' }],
    route: '/reporting/conversion',
  },
  {
    name: 'Custom',
    id: 'reporting-custom',
    mpid: 'reporting',
    abilities: [{ subject: 'Partner', field: 'customCharts' }],
    route: '/reporting/custom',
  },
  {
    name: 'Settings',
    id: 'settings',
    icon: SettingOutlined,
    route: '/settings',
  },
  {
    name: 'General',
    id: 'settings-general',
    mpid: 'settings',
    abilities: [
      { action: 'update', subject: 'PartnerSettings', field: 'appearance' },
    ],
    route: '/settings/general',
  },
  {
    name: 'Community',
    id: 'settings-community',
    mpid: 'settings',
    abilities: [
      {
        action: 'update',
        subject: 'PartnerSettings',
        field: 'community',
      },
    ],
    route: '/settings/community',
  },
  {
    name: 'Engagement',
    id: 'settings-engagement',
    mpid: 'settings',
    abilities: [{ action: 'update', subject: 'PartnerSettings' }],
    route: '/settings/engagement',
  },
  {
    name: 'Members',
    id: 'settings-members',
    mpid: 'settings',
    abilityMode: 'any',
    abilities: [
      { subject: 'Partner', field: 'members' },
      { subject: 'Partner', field: 'invitations' },
      { action: 'create', subject: 'ExpertEdge', field: 'roles' },
      { action: 'update', subject: 'ExpertEdge', field: 'roles' },
    ],
    route: '/settings/members',
  },
  {
    name: 'Integrations',
    id: 'settings-integrations',
    mpid: 'settings',
    abilities: [
      { action: 'update', subject: 'PartnerSettings', field: 'integrations' },
    ],
    route: '/settings/integrations',
  },
  {
    name: 'Developer',
    id: 'settings-developer',
    mpid: 'settings',
    abilityMode: 'any',
    abilities: [
      { subject: 'PartnerSettings', field: 'tokens' },
      { subject: 'PartnerSettings', field: 'developerWebHooks' },
    ],
    route: '/settings/developer',
  },
  {
    name: 'Billing',
    id: 'settings-billing',
    mpid: 'settings',
    abilityMode: 'any',
    abilities: [
      { subject: 'Partner', field: 'balances' },
      { subject: 'Partner', field: 'account' },
      { subject: 'Partner', field: 'discounts' },
      { subject: 'Partner', field: 'surcharges' },
      { subject: 'PartnerSettings', field: 'bills' },
      { subject: 'PartnerSettings', field: 'billing' },
    ],
    route: '/settings/billing',
  },
  {
    name: 'Invoice',
    id: 'settings-billing',
    mpid: '-1',
    abilityMode: 'any',
    abilities: [
      { subject: 'Partner', field: 'balances' },
      { subject: 'Partner', field: 'charges' },
      { subject: 'Partner', field: 'payouts' },
    ],
    route: '/settings/billing/invoices/:year/:month',
  },
];

export default mainMenu;
